// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"4c25ad7e2393f9f3af04","740":"9b671dbde2dccbd88fb7"}[chunkId] + ".css";
};